import { ClinicalItemLog } from '@features/components/ClinicalData/types';
import { RadiometerLayout } from '@features/components/ClinicalData/components/ClinicalLog/components/RadiometerLayout';
import { Gallery } from '@features/components/ClinicalData/components/ClinicalLog/components/Gallery';
import { useState } from 'react';
import { getPfRatioOnOCSData } from '@features/components/ClinicalData/components/ClinicalLog/LogItems/utils';
import { ClinicalItemType } from '@/api/apis/case';
import { MeasurementRow } from '../components/MeasurementRow';

type PfRationOnOCSProps = {
  event: string;
  item: ClinicalItemLog<ClinicalItemType.PFRatioOnOCSDonorHospital | ClinicalItemType.PFRatioOnOCSTXCenter>;
  onShareClick?: () => void;
  isTrialCase: boolean;
  shared?: boolean;
};

export const PfRatioOnOCS = ({ event, item, onShareClick, isTrialCase, shared }: PfRationOnOCSProps) => {
  const [selectedFileIndex, setSelectedFileIndex] = useState(0);
  const pfRatioOnOCSData = getPfRatioOnOCSData(item, isTrialCase);

  return (
    <RadiometerLayout
      shared={shared}
      onShareClick={onShareClick}
      event={event}
      measurements={pfRatioOnOCSData.commonMeasurements}
    >
      {pfRatioOnOCSData.data.map(({ name, value }) => (
        <MeasurementRow label={name} value={value} key={name} />
      ))}
      <Gallery
        heading={event}
        mediaFiles={item.mediaFiles}
        selectedFileIndex={selectedFileIndex}
        setSelectedFileIndex={setSelectedFileIndex}
        onShareClick={onShareClick}
        isFromClinicalLog
      />
    </RadiometerLayout>
  );
};
